<template>
  <!-- <el-tooltip v-if="!$route.path.includes('/s/')" class="item" effect="dark" content="Draw it 2" placement="top-start"> -->
    <el-button type="primary" round icon="el-icon-edit" @click="openDraw">{{title}}</el-button>
  <!-- </el-tooltip> -->

  <!-- <el-dialog
    :visible.sync=""
    width="30%"
    center>
    <span>需要注意的是内容是默认不居中的</span>
    <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
    </span>
    </el-dialog> -->
</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex'
export default {
  props: {
    title: {type: String, default: 'Annotate'},
    pic: {type: String, default: ''},
    isCollab: {type:Boolean, default: false},
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    ...mapState(['session']),
    ...mapState('teacher', ['rooms']),
    ...mapGetters(['getPage', 'getPageId']),
  },
  methods: {
    ...mapActions(['setSyncUI']),
    openDraw() {
      const drawUrl = `/v2/draw/teacher/${this.rooms.sid}?pageId=${this.getPageId}&pic=${this.getPage?.pic || this.getPage?.url}` + (this.isCollab ? '&collab=true' : '')
      this.$store.commit('setSyncUI', {drawUrl})
    },
    drawOk() {
      // If we are in a demo replay session, don't trigger the global student-facing 'Join Annotation' icon
      if (this.isCollab && !this.session?.demoReplay) {
        this.setSyncUI({drawShow: true}) // Notify others to join
      } else {
        console.log('Annotation ready (Demo or Local mode - skipping student notification)')
      }
    },
    drawClose() {
      this.$store.commit('setSyncUI', {drawUrl: ''})
    }
  },
  mounted() {
    window.drawClose = this.drawClose
    if (this.isCollab) window.drawOk = this.drawOk
  },
}
</script>
